import { useStyleSheet } from '../../../hooks/useStyleSheet';
import { OptionFormatterVariantLiterals } from '../../inputs/selectOptions/SelectOption';

export const useStyles = (variant: OptionFormatterVariantLiterals) => {
  return useStyleSheet((theme) => ({
    root: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0, 1fr) auto',
      gap: theme.spacing.secondary,
    },
    label: {
      color: variant === 'option' ? theme.palette.primary.main : theme.palette.text.primary,
      fontSize: theme.fontSizes.h5,
    },
    iconContainer: {
      display: 'flex',
      gap: theme.spacing.secondary,
    },
  }));
};
